import React from 'react'

import AuthScreen from '../components/modern-login/AuthScreen';

export default function ModernLogin() {
    return (
        <AuthScreen />
    )
}
